import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { actionGenerator } from '../../redux/actionGenerator';
import { prepareFormInitialState } from '../../mappers/formInitialState';
import { EFormInitialStateActionType } from './types';
var update = actionGenerator(EFormInitialStateActionType.Updated);
export function updateFormInitialState(nextState) {
  var _ref;
  return function (_x, _x2, _x3) {
    return (_ref = _ref || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var preparedNextState;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            preparedNextState = prepareFormInitialState(nextState);
            dispatch(update(preparedNextState));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))).apply(this, arguments);
  };
}